import React from 'react';
import { Hidden, makeStyles } from '@material-ui/core';
import { Button } from 'rsuite';
import config from '@/configs/config';
import bbImage from './images/foodpartners_bb_mobile.png';
import featuresImage from './images/features_mobile.png';
import dFoodPicsImage from './images/foodpics.png';
import foodPicsImage from './images/foodpics_mobile.png';
import brandsBgImage from './images/partnerslogo_bg_mobile.png';
import dBrandsBgImage from './images/partnerslogo_bg.png';
import partnersLogosImage from './images/partners_logos_mobile.png';
import dPartnersLogosImage from './images/partners_logo.png';
import pricingA from './images/pricingA.png';
import pricingB from './images/pricingB.png';
import pricingC from './images/pricingC.png';
import aImage from './images/A.png';
import bImage from './images/B.png';
import cImage from './images/C.png';
import dImage from './images/D.png';
import eImage from './images/E.png';
import fImage from './images/F.png';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 14,
  },
  bbContainer: {
    alignItems: 'center',
    backgroundImage: `url(${bbImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    color: 'white',
    display: 'flex',
    fontSize: 32,
    fontWeight: 'bold',
    height: 228,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      height: 661,
    },
  },
  bbContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'start',
      width: '100%',
      fontSize: 62,
      height: 661,
      maxWidth: 768,
    },
  },
  bbButton: {
    background: theme.palette.primary.main,
    borderRadius: 4,
    color: 'black',
    fontSize: 14,
    marginTop: theme.spacing(1),
    padding: theme.spacing(0.5, 3),

    [theme.breakpoints.up('sm')]: {
      fontSize: 28,
      marginTop: theme.spacing(3),
    },
  },
  bbDescription: {
    fontSize: 14,
    fontWeight: 'normal',
    [theme.breakpoints.up('sm')]: {
      fontSize: 24,
    },
  },
  content: {
    alignItems: 'center',
    color: '#4f4f4f',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 768,
      fontSize: 16,
    },
  },
  contentTitle: {
    color: 'black',
    fontSize: 20,
    fontWeight: 'bold',

    [theme.breakpoints.up('sm')]: {
      fontSize: 40,
    },
  },
  contentBody: {
    marginTop: 12,
    color: '#4f4f4f',

    [theme.breakpoints.up('sm')]: {
      fontSize: 16,
    },
  },
  contentImages: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: theme.spacing(5, 0),
    maxWidth: 768,

    '& > *': {
      marginTop: theme.spacing(2),
    },
  },
  foodPicsContainer: {
    height: 508,
    position: 'relative',
    width: '100%',
  },
  foodPics: {
    backgroundImage: `url(${foodPicsImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: 508,
    padding: theme.spacing(3, 0),
    position: 'absolute',
    width: '100%',
    zIndex: 1,
  },
  foodPicsContent: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    fontWeight: 'bold',
    height: 350,
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-55%)',
    width: '100%',
  },
  planContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    fontWeight: 'bold',
    justifyContent: 'center',
    padding: theme.spacing(3, 0),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      background: '#e9e9e9',
      paddingBottom: 0,
    },
  },
  planButtonContainer: {
    marginTop: theme.spacing(4),
    textAlign: 'center',
  },
  planButton: {
    background: '#00a115',
    borderRadius: 4,
    color: 'white',
    fontSize: 27,
    padding: theme.spacing(0.5, 3),
  },
  planHeader: {
    border: 0,
    borderBottomWidth: 3,
    borderColor: 'black',
    borderStyle: 'solid',
    borderTopWidth: 3,
    boxSizing: 'border-box',
    fontSize: 20,
    padding: theme.spacing(1),
  },
  planBody: {
    fontSize: 35,
    fontWeight: 'bold',
    marginTop: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      alignItems: 'end',
      display: 'flex',
      marginTop: 0,
    },
  },
  planFooter: {
    fontSize: 35,

    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  planFirst: {
    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  planSecond: {
    color: '#ffb120',
    fontSize: 42,
    [theme.breakpoints.up('sm')]: {
      fontSize: 60,
    },
  },
  planThird: {
    [theme.breakpoints.up('sm')]: {
      fontSize: 50,
    },
  },
  brandsContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
  },
  brandsHeader: {
    alignItems: 'center',
    background: theme.palette.primary.main,
    display: 'flex',
    fontSize: 40,
    fontWeight: 'bold',
    height: 92,
    justifyContent: 'center',
    width: '100%',
  },
  brandsBody: {
    alignItems: 'center',
    backgroundImage: `url(${brandsBgImage})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 250,
    justifyContent: 'center',
    padding: theme.spacing(3),
    width: '100%',

    [theme.breakpoints.up('sm')]: {
      backgroundImage: `url(${dBrandsBgImage})`,
    },
  },
  priceBg: {
    background: '#e9e9e9',
    bottom: 0,
    height: '15%',
    position: 'absolute',
    width: '100%',
  },
  featuresBg: {
    background: theme.palette.primary.main,
    height: '70%',
    position: 'absolute',
    width: '100%',
  },
  pricingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 768,
  },
  pricingImage: {
    width: '30%',
  },
}));

export default ({ formLink }) => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <div className={classes.bbContainer}>
        <div className={classes.bbContent}>
          <span>快速展店</span>
          <span>進駐精華商辦</span>
          <span className={classes.bbDescription}>微型無人商店 24小時為您服務</span>
          <Button
            className={classes.bbButton}
            target="_blank"
            href={formLink}
          >
            立即諮詢
          </Button>
        </div>
      </div>
      <div className={classes.content}>
        <span className={classes.contentTitle}>
          成為
          {config.BrandNameTW}
          餐食夥伴
        </span>
        <div className={classes.contentBody}>
          <span>
            {config.BrandNameTW}
            將您餐廳的美食送到台北市區各個商辦販售，目前擁有八十餘個營業據點，
          </span>
          <span>配合店家數目經超過三百間，每週提供上萬份餐食讓消費者們享用。</span>
          <span>
            若您有合適的餐食，無論是主食餐盒、輕食甜點、零食飲料或是適合預購的團購美食伴手禮，
          </span>
          <span>
            都歡迎聯繫我們業務團隊來進一步了解，我們將由專人與您進行後續合作細節的接洽，期待您的來信。
          </span>
        </div>
        <Hidden xsDown>
          <div className={classes.contentImages}>
            <img src={aImage} alt="30秒快速結帳,電子支付金流透明" />
            <img src={bImage} alt="快速拓展據點,餐食每日新鮮上架" />
            <img src={cImage} alt="超近距離零售,近在咫尺的銷售通路" />
            <img src={dImage} alt="今天訂明天取!,商品線上預定/機台自取" />
            <img src={eImage} alt="50,000+會員經營,品牌上架有效曝光" />
            <img src={fImage} alt="無接觸購餐,自助購餐好安心" />
          </div>
        </Hidden>
        <Hidden smUp>
          <img src={featuresImage} alt="" width="100%" style={{ marginTop: 24 }} />
        </Hidden>
      </div>
      <Hidden xsDown>
        <div style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          marginTop: 24,
          position: 'relative',
          width: '100%',
        }}
        >
          <div className={classes.featuresBg} />
          <img
            src={dFoodPicsImage}
            alt="開放式層架，陳列彈性,飲料、甜點、餐盒、零食都適合上架"
            width="100%"
            style={{ zIndex: 1, maxWidth: 768 }}
          />
          <div className={classes.priceBg} />
        </div>
      </Hidden>
      <Hidden smUp>
        <div className={classes.foodPicsContainer}>
          <div className={classes.foodPics} />
          <div className={classes.foodPicsContent}>
            <span style={{ fontSize: 30 }}>開放式層架，陳列彈性</span>
            <span style={{ marginTop: 24, fontSize: 18 }}>飲料、甜點、餐盒、零食都適合上架</span>
          </div>
        </div>
      </Hidden>
      <div className={classes.planContainer}>
        <span className={classes.planHeader}>合作方案</span>
        <div className={classes.planBody}>
          <span className={classes.planFirst}>最低</span>
          <span className={classes.planSecond}>每日50元</span>
          <span className={classes.planThird}>起</span>
        </div>
        <span className={classes.planFooter}>立即上架體驗</span>
        <div className={classes.planButtonContainer}>
          <Button
            className={classes.planButton}
            target="_blank"
            href={formLink}
          >
            請專人聯繫我

          </Button>
        </div>
        <Hidden xsDown>
          <div className={classes.pricingContainer}>
            <img src={pricingA} alt="A.小試身手" width="100%" className={classes.pricingImage} />
            <img src={pricingB} alt="B.品牌發展" width="100%" className={classes.pricingImage} />
            <img src={pricingC} alt="C.企業連鎖" width="100%" className={classes.pricingImage} />
          </div>
        </Hidden>
      </div>
      <div className={classes.brandsContainer}>
        <span className={classes.brandsHeader}>合作品牌</span>
        <div className={classes.brandsBody}>
          <Hidden xsDown>
            <img src={dPartnersLogosImage} alt="" width="100%" />
          </Hidden>
          <Hidden smUp>
            <img src={partnersLogosImage} alt="" width="100%" />
          </Hidden>
        </div>
      </div>
    </div>
  );
};
